import qs from "query-string";

import { QueryParams, QueryString } from "../types";

export function parse<Values extends QueryParams>(input: string): Partial<Values> {
  return qs.parse(input, {
    arrayFormat: "bracket",
    parseBooleans: true,
    parseNumbers: true,
  }) as Partial<Values>;
}

export function stringify<Values extends QueryParams>(values: Values): string {
  return qs.stringify(values, {
    arrayFormat: "bracket",
    skipEmptyString: true,
    skipNull: false,
  });
}

export function getQueryStringValues<Values extends QueryParams>(
  queryString: QueryString,
  defaultValues: Values,
): Values {
  const values = { ...defaultValues };
  const keys = Object.keys(values) as Array<keyof Values>;

  const queryParams = parse<Values>(queryString);

  keys.forEach((key) => {
    if (queryParams[key] !== undefined) {
      values[key] = queryParams[key];
    }
  });

  return values;
}
